<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="widget-newsletter-title">{{ translations.signUpForTheNewsletter }}</div>
          </div>
          <div class="col-lg-4">
            <p class="widget-newsletter-content">
              {{ translations.latestInformations }}<br />
            </p>
          </div>
          <div class="col-lg-5">
            <form @submit.prevent="onFormSubmit" novalidate>
              <div class="footer-submit-wrapper">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Unesite Vašu e-mail adresu"
                  v-model="email"
                  required
                />
                <button type="submit" class="btn">{{ translations.subscribe }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-middle">
        <div class="row row-sm">
          <div class="col-md-3">
            <div class="widget">
              <h4 class="widget-title">{{ translations.aboutUs }}</h4>
              <ul class="links">
                <li><router-link :to="{ name: 'About' }">
                  {{ translations.aboutEurosanGroup }}</router-link></li>
                <li><a href="https://eurosan.ba/karijere/">{{ translations.jobAtEurosan }}</a></li>
                <li><router-link :to="{ name: 'ResponsibleBusiness' }">
                  {{ translations.responsibleBusiness }}
                  </router-link></li>
                <li>
                  <router-link :to="{ name: 'Blogs' }">
                    {{ translations.blog }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Contact' }">
                    {{ translations.contact }}
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- End .widget -->
          </div>
          <!--end col-->
          <div class="col-md-3">
            <div class="widget">
              <h4 class="widget-title">{{ translations.onlineShopping }}</h4>
              <ul class="links">
                <li>
                  <router-link :to="{ name: 'Profile' }">
                    {{ translations.myAccount2 }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PaymentMethodsAndDelivery' }">
                    {{ translations.deliveryAndPayment }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Complaints' }">
                    {{ translations.complaintsAndReturns }}
                  </router-link>
                </li>
                <li><a href="#">{{ translations.bonusProgramRules }}</a></li>
                <li>
                  <router-link
                    :to="{ name: 'SecurityAndPrivacy' }"
                  >
                  {{ translations.securityAndPrivacy }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'TermsOfService' }">
                    {{ translations.termsOfService }}
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- End .widget -->
          </div>
          <!--end col-->
          <div class="col-md-3">
            <div class="widget">
              <h4 class="widget-title">{{ translations.youNeedHelp }}</h4>
              <ul class="links">
                <li>
                  <router-link :to="{ name: 'FAQ' }">{{ translations.faq }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'HowToRegister' }">
                    {{ translations.howToRegister }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Help' }"> {{ translations.shoppingHelp }}</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Service' }">{{ translations.service }}</router-link>
                </li>
              </ul>
            </div>
            <!-- End .widget -->
          </div>
          <!--end col-->
          <div class="col-md-3">
            <div class="widget">
              <h4 class="widget-title">{{ translations.followUsOnSocialMedia }}</h4>
              <ul class="links footer-social-wrapper">
                <li>
                  <a href="https://www.facebook.com/eurosan.ecotime" target="_blank">
                    <i class="fab fa-facebook-f footer-social footer-social-padding-f"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/eurosan.ecotime" target="_blank">
                    <i class="fab fa-instagram footer-social footer-social-padding-i"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCGaL2EJJIpbrlrTv-Y76cnw" target="_blank">
                    <i class="fab fa-youtube footer-social"></i>
                  </a>
                </li>
                <li><a target="_blank" href="https://www.linkedin.com/company/eurosanecotime/">
                  <i class="fab fa-linkedin footer-social"></i>
                </a></li>
                <li>
                  <a target="_blank" href="https://www.tiktok.com/@eurosan.ecotime">
                    <svg class="footer-social" style="fill: #1e84bc;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6
                      162.6 0 1 1 185 188.3V278.2a74.6
                      74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0
                      0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <!-- End .widget -->
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright-left">
          Eurosan B2B. &copy; {{ currentYear }}. {{ translations.allRightsReserved }}
        </p>
        <p class="footer-copyright-right">
          Powered by XSOFT d.o.o. Mostar
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import api from '@/services/api';
import { translations } from '@/mixins';
import validations from './validation-schema/schema';

export default {
  name: 'Footer',
  validations,
  mixins: [translations],
  data() {
    return {
      email: '',
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    onFormSubmit() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const payload = {
        email: this.email,
        type: 3,
      };

      api
        .subscribeToNewsletter(payload)
        .then((response) => {
          this.$router.push({ name: 'NewsletterSuccess', query: { message: response.data.info } });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
};
</script>
<style lang="css" scoped>
.footer {
  margin-top: auto;
  width: 100%;
}

.footer-middle {
  padding-top: 3rem;
}

.footer-social-wrapper {
  display: flex;
}

.footer-social {
  background: #ffffff;
  color: #1e84bc;
  border-radius: 50%;
  padding: 10px 10px 10px 10px;
  width: 40px;
  height: 40px;
  margin-right: 15px;
  font-size: 18px;
}

.footer-social-padding-f {
  padding-left: 15px;
}
.footer-social-padding-i {
  padding-left: 12px;
}
</style>
